type SoundType = 'select' | 'correct' | 'mistake' | 'victory' | 'erase';
let audioContext: AudioContext | null = null;
const getAudioContext = (): AudioContext => {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  return audioContext;
};
export const triggerHaptic = (): void => {
  if (typeof navigator !== 'undefined' && navigator.vibrate) {
    navigator.vibrate(40);
  }
};
const playTone = (
  frequency: number,
  duration: number,
  type: OscillatorType = 'sine',
  gain: number = 0.3
): void => {
  try {
    const ctx = getAudioContext();
    if (ctx.state === 'suspended') {
      ctx.resume();
    }
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();
    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);
    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, ctx.currentTime);
    gainNode.gain.setValueAtTime(gain, ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration / 1000);
    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + duration / 1000);
  } catch {
    // Audio not available
  }
};
const playChord = (
  frequencies: number[],
  duration: number,
  type: OscillatorType = 'sine',
  gain: number = 0.2
): void => {
  frequencies.forEach((freq) => playTone(freq, duration, type, gain));
};
export const playSound = (type: SoundType): void => {
  try {
    const ctx = getAudioContext();
    if (ctx.state === 'suspended') {
      ctx.resume();
    }
    switch (type) {
      case 'select':
        playTone(440, 50, 'sine', 0.15);
        break;
      case 'correct':
        playChord([523, 659], 100, 'sine', 0.2);
        break;
      case 'mistake':
        playTone(220, 200, 'sawtooth', 0.15);
        break;
      case 'victory':
        setTimeout(() => playChord([523, 659, 784], 150, 'sine', 0.25), 0);
        setTimeout(() => playChord([659, 784, 1047], 150, 'sine', 0.25), 150);
        setTimeout(() => playChord([784, 1047, 1319], 300, 'sine', 0.3), 300);
        break;
      case 'erase':
        playTone(330, 80, 'sine', 0.1);
        break;
    }
  } catch {
    // Audio not available
  }
};